import get from 'lodash/get';
import debounce from 'lodash/debounce';
import '../domain/error-state/error-state.component'


function TenantDetailsCtrl($stateParams, TenantsService, DomainsService, TimezonesService,
                           DistributorsService, $state, sweet, ProgressBarService, ReportingService, AuthV2Service,
                           $log, ToastsService, SessionsService, $scope, $location, StorageService) {
  "ngInject";

  let vm = this;
  vm.gameStopServer = $location.host().indexOf('provisioning-gamestop') > -1;
  vm.showCdmInfo = false;
  
  vm.currentTenant = {
    key: undefined,
    name: undefined,
    code: undefined,
    adminEmail: undefined,
    contentServerUrl: undefined,
    contentManagerBaseUrl: undefined,
    domainId: undefined,
    notificationEmails: undefined,
    customerName: undefined,
    intacctId: undefined,
    proofOfPlayLogging: false,
    proofOfPlayUrl: undefined,
    beaconOptionAvailable: false,
    beaconTypeDefault: undefined,
    beaconUrlDefault: undefined,
    deviceUsageTypeDefault: undefined,
    active: true,
    defaultHoursOfOperation: undefined,
    selectedEditionName: undefined,
    selectedAddons: []
  };
  vm.selectedDomain = undefined;
  vm.distributorDomains = [];
  vm.timezones = [];
  vm.selectedTimezone = 'America/Chicago';
  vm.editMode = !!$stateParams.tenantId;
  vm.isTenant = SessionsService.getIsTenant();
  vm.isTenantAdmin = SessionsService.isTenantAdmin($stateParams.tenantId);
  vm.isPlatformAdmin = SessionsService.getIsPlatformAdmin();
  vm.admin = SessionsService.getIsAdmin();
  vm.isManagingOrgAdmin;
  vm.ouFound = false;
  vm.rawCmTenantInfo = undefined;
  vm.selectedEditionAddonNames = [];
  vm.editionAddonIds = [];
  vm.editionNameKeyPairs = {};
  vm.editionAddonNameKeyPairs = {};
  vm.editionsList = [];
  vm.editionsListNames = [];
  vm.editionAddonsList = [];
  vm.editionAddonsListNames = [];
  vm.editionAddonList = [];
  vm.defaultHoursOfOperationJsonEditorOptions = {
    options: {
      mode: 'code',
      change: function () {
        try {
          // on each change, attempt to get the json text
          // if it excepts, it means it's invalid json
          let json = vm.defaultHoursOfOperationJsonEditorInstance.get();
          if (json === vm.currentTenant.defaultHoursOfOperation) {
            vm.defaultHoursOfOperationConfigurationPristine = true;
          } else {
            vm.defaultHoursOfOperationConfigurationPristine = false;
          }
          vm.buttonDisabled = false;
        } catch (E) {
          vm.buttonDisabled = true;
        }
      }
    }
  };

  if (!$stateParams.tenantId || $stateParams.tenantId === '') {
    sweet.show('Oops...', 'You must include a tenantId in your path', 'error');
    history.go(-1);
  }

  vm.initialize = function () {
    let timezonePromise = TimezonesService.getCustomTimezones();
    timezonePromise.then(data => vm.timezones = data);
  };

  vm.getDistributorDomains = (tenantData) => {
    const hasOrgEdges = get(tenantData, 'organization.domains.edges.length');
    let mappedOrg = [];

    if (hasOrgEdges) {
      const edges = get(tenantData, 'organization.domains.edges');

      mappedOrg = edges.map(e => ({
        id: e.node.id,
        lid: e.node.lid,
        name: e.node.name
      }));
    }
    
    vm.distributorDomains = mappedOrg;
  };

  vm.getTenantManagingOrg = (managingOrgId) => {
    return DistributorsService.getById(managingOrgId)
      .then((resp) => {
        // vm.currentManagingOrganization = resp.name;
        vm.isManagingOrgAdmin = SessionsService.isManagingOrgAdmin(resp.id);
      });
  };

  vm.onSuccessResolvingTenant = async function (tenant) {
    
    vm.showCdmInfo = tenant.organizationUnitPath && tenant.enrollmentEmail && tenant.enrollmentPassword;
    if(vm.showCdmInfo){
      vm.startEnrollmentUserCheck();
      vm.startOUContainerCheck();
    } else {
      console.debug('Could not get CDM info')
    }
    vm.selectedTimezone = tenant.defaultTimezone;
    if (tenant.deviceUsageTypeDefault === null || tenant.deviceUsageTypeDefault === undefined) {
      vm.selectedUsageType = 'None';
    } else {
      vm.selectedUsageType = tenant.deviceUsageTypeDefault;
    }
    await vm.getEditionAddOnsList(tenant);
  };

  vm.defaultHoursOfOperationConfigurationOptions = (defaultHoursOfOperationJsonEditorInstance) => {
    vm.defaultHoursOfOperationJsonEditorInstance = defaultHoursOfOperationJsonEditorInstance
  };

  vm.getEditionAddOnsList = async function(currentTenant){
    try {
      const ngEditionsResp = await AuthV2Service.getEditions();
      const ngEditionsData = _.get(ngEditionsResp, 'data.data.editions');
      const ngAddonsData = _.get(ngEditionsResp, 'data.data.addons');

      vm.editionAddonList = ngAddonsData.filter(x => x.name);
      vm.editionsListNames = ngEditionsData.map(x => x.name);
      vm.editionsList = ngEditionsData;

      const { name = '' } = ngEditionsData.find(x => x.id === currentTenant.edition.id);

      vm.currentTenant.selectedEditionName = name;
    } catch (err) {
      console.error(err);
      return ToastsService.showErrorToast('Oops. We are currently unable retrieve the editions list at this time.');
    }
  };

  vm.checkItemSelected = (item) => vm.currentTenant.selectedAddOns.find(x => x.lid === item.lid);

  vm.toggleAddOns = (item) => {
    if (vm.currentTenant.selectedAddOns && vm.currentTenant.selectedAddOns.find(x => x.lid === item.lid)) {
      const idx = vm.currentTenant.selectedAddOns.findIndex(x => x.lid === item.lid);
      vm.currentTenant.selectedAddOns.splice(idx, 1);
    } else {
      vm.currentTenant.selectedAddOns.push(item);
    }
  }

  vm.onSuccessRetrievingOu = function (ouFound){
    vm.ouFound = ouFound;
    ProgressBarService.complete();
  };

  vm.onFailureRetrievingOu = function (error) {
    ProgressBarService.complete();
    $log.error('Failure attempting to retrieve orgunit info');
    return ToastsService.showErrorToast('Oops. We were unable determine your OU availability at this time.');
  };

  vm.startOUContainerCheck = () => {
    if (vm.editMode) {
      ProgressBarService.start();
      let ouRetrievalPromise = TenantsService.checkTenantOu(vm.currentTenant.key);
      return ouRetrievalPromise.then(vm.onSuccessRetrievingOu, vm.onFailureRetrievingOu);
    }
  };

  vm.startEnrollmentUserCheck = () => {
    if (vm.editMode) {
      let enrollUserRetrievalPromise = TenantsService.checkTenantEnrollmentUser(vm.currentTenant.key);
      return enrollUserRetrievalPromise.then(vm.onSuccessRetrievingEnrollmentUser, vm.onFailureRetrievingEnrollmentUser );
    }
  };

  vm.onSuccessRetrievingEnrollmentUser = function (enrollmentUserFound){
    vm.enrollmentUserFound = enrollmentUserFound;
  };

  vm.onFailureRetrievingEnrollmentUser = function (error) {
    $log.error('Failure attempting to retrieve enrollment user info');
    return ToastsService.showErrorToast('Oops. We were unable determine your enrollment user availability at this time.');
  };

  vm.getDomainData = () => {
    if (vm.editMode) {
      let domainPromise = DomainsService.getDomainById(vm.currentTenant.domain.id);
      domainPromise.then(data => {
        vm.currentDomain = data;
      });
    }  else {
       vm.currentDomain.distributor_key = SessionsService.getCurrentDistributorKey();
    }
  };

  if (vm.editMode) {
    ProgressBarService.start();

    SessionsService.getAuthV2()
      .then(authResp => {
        const isPlatformAdmin = get(authResp, 'data.data.identity.platformAdminActive');
        StorageService.set('isPA', isPlatformAdmin);

        vm.isPlatformAdmin = isPlatformAdmin;
      })
      .catch(err => {
        console.error(`Could not access auth v2 data, ${err}`);
        StorageService.set('isPA', false);
      })
      .then(() => {
        return TenantsService.getTenantV2Data({id:`tenants/${SessionsService.getSelectedTenantCode()}`}, SessionsService.getIsPlatformAdmin())
      })
      .then(resp => {
        const tenantData = get(resp, 'data.data.node');

        if (!tenantData) {
          console.debug(`tenant data not available`);
          sweet.show('Oops...', 'Unable to get tenant data', 'error');
        } else {
          vm.mapNgToOGTenantData(tenantData);
          vm.onSuccessResolvingTenant(vm.currentTenant);
        }

        if (!get(tenantData, 'organization.legacyAcId')) {
          console.debug(`Unable to get distributor domain`);
        } else {
          vm.getDistributorDomains(tenantData);
        }

        if (!get(tenantData, 'organization.legacyAcId')) {
          console.debug(`Unable to get managing org`);
        } else {
          vm.getTenantManagingOrg(get(tenantData, 'organization.legacyAcId'));
        }

        ProgressBarService.complete();
      })
      .catch(err => {
        console.error(err);
        sweet.show('Oops...', 'Unable to fetch tenant', 'error');
      });
  }

  vm.mapNgToOGTenantData = (ngData) => {
    vm.currentTenant = {
      id: get(ngData, 'legacyAcId'),  // USed for saving
      key: get(ngData, 'legacyAcId'), // Per BE, no longer valid for NG
      name: get(ngData, 'name'),
      code: get(ngData, 'lid'),
      adminEmail: vm.getCommaDelimitedString(ngData.adminEmails),
      contentServerUrl: undefined, // Per BE, no longer valid for NG
      contentManagerBaseUrl: undefined, // Per BE, no longer valid for NG
      domainGid: get(ngData, 'domain.id'),
      notificationEmails: vm.getCommaDelimitedString(ngData.notificationEmails),
      customerName: get(ngData, 'customerName'),
      intacctId: get(ngData, 'intacctId'),
      proofOfPlayLogging: undefined, // Per BE, no longer valid for NG
      proofOfPlayUrl: undefined, // Per BE, no longer valid for NG
      beaconOptionAvailable: false, // Per BE, no longer valid for NG
      beaconTypeDefault: undefined, // Per BE, no longer valid for NG
      beaconUrlDefault: undefined, // Per BE, no longer valid for NG
      deviceUsageTypeDefault: get(ngData, 'usageType'),
      active: get(ngData, 'enabled'),
      // new 
      defaultTimezone: get(ngData, 'timezone'),
      supportNotes: get(ngData, 'supportNotes'),
      defaultShowContentProgress: get(ngData, 'defaultShowContentProgress'),
      currentManagingOrganization: get(ngData, 'organization.name'),
      defaultHoursOfOperation: get(ngData, 'defaultHoursOfOperation'),
      edition: get(ngData, 'edition'),
      selectedAddOns: get(ngData, 'addons')
    };
  }

  vm.getCommaDelimitedString = (arr) => {
    if (arr) {
      if (arr.length > 1) {
        return arr.join(', ');
      } else if (arr.length === 1) {
        return arr.pop();
      }
    } else {
      return '';
    }
  };

  vm.onClickSaveButtonV2 = debounce(async () => {
    const selectedEditionGid = vm.editionsList.find(x => x.name === vm.currentTenant.selectedEditionName) && vm.editionsList.find(x => x.name === vm.currentTenant.selectedEditionName).gidV3;
    
    const payload = {
      addonGids: vm.currentTenant.selectedAddOns.map(x => x.gidV3),
      adminEmails: vm.currentTenant.adminEmail && vm.currentTenant.adminEmail.length ? vm.currentTenant.adminEmail.split(',') : [],
      customerName: vm.currentTenant.customerName,
      defaultHoursOfOperation: vm.currentTenant.defaultHoursOfOperation,
      defaultShowContentProgress: vm.currentTenant.defaultShowContentProgress,
      editionGid: selectedEditionGid,
      intacctId: vm.currentTenant.intacctId,
      lid: vm.currentTenant.code,
      name: vm.currentTenant.name,
      notificationEmails: vm.currentTenant.notificationEmails && vm.currentTenant.notificationEmails.length ? vm.currentTenant.notificationEmails.split(', ') : [],
      supportNotes: vm.currentTenant.supportNotes,
      timezone: vm.selectedTimezone,
      usageType: vm.selectedUsageType,
      // domainGid: vm.currentTenant.domainGid // TODO: leave out for now
    }

    try {
      ProgressBarService.start();
      await TenantsService.updateTenantV2(payload);
      ProgressBarService.complete();
    } catch(err) {
      console.error(err);
      sweet.show('Oops...', 'Failed to save', 'error');
      ProgressBarService.complete();
    }
  }, 600);

  vm.onSuccessTenantSave = function () {
    ProgressBarService.complete();
    return ToastsService.showSuccessToast('We saved your tenant information.');
  };

  vm.onFailureTenantSave = function (errorObject) {
    ProgressBarService.complete();
    if (errorObject.status === 409) {
      return sweet.show('Oops...',
        'Tenant code unavailable. Please modify tenant name to generate a unique tenant code.', 'error');
    } else {
      return sweet.show('Oops...', 'Unable to save the tenant.', 'error');
    }
  };

  vm.editItem = item => $state.go('main.editDevice', {deviceId: item.key, tenantId: $stateParams.tenantId});

  vm.autoGenerateTenantCode = function () {
    if (!vm.currentTenant.key) {
      let newTenantCode = '';
      if (vm.currentTenant.name) {
        newTenantCode = vm.currentTenant.name.toLowerCase();
        newTenantCode = newTenantCode.replace(/\s+/g, '_');
        newTenantCode = newTenantCode.replace(/\W+/g, '');
      }
      return vm.currentTenant.code = newTenantCode;
    }
  };

  vm.generateDisplayReport = () => {
    let reportUrl = ReportingService.deviceReportUrl({tenantId:$stateParams.tenantId});
    return reportUrl
  };

  $scope.tabIndex = 0;

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  return vm;
}
export {TenantDetailsCtrl}
